var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "portlet solid bordered grey-cararra" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "portlet-body" }, [
      _c("div", {
        staticClass: "chart",
        staticStyle: { width: "100%", "background-color": "#FFFFFF" },
        style: { height: _vm.heightChart },
        attrs: { id: _vm.idGrafico },
      }),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "portlet-title" }, [
      _c("div", { staticClass: "caption" }, [
        _c("i", { staticClass: "fa fa-spin fa-cog" }),
        _vm._v("\n            Carregando...\n        "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }